'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'info',
  aliases: ['info-circle'],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF05A',
    glyphName: 'info_sign',
    transform: 'scale(1,-1) translate(0, -1536)',
    horizAdvX: '1536',
    d: 'M1024 160v160q0 14 -9 23t-23 9h-96v512q0 14 -9 23t-23 9h-320q-14 0 -23 -9t-9 -23v-160q0 -14 9 -23t23 -9h96v-320h-96q-14 0 -23 -9t-9 -23v-160q0 -14 9 -23t23 -9h448q14 0 23 9t9 23zM896 1056v160q0 14 -9 23t-23 9h-192q-14 0 -23 -9t-9 -23v-160q0 -14 9 -23\nt23 -9h192q14 0 23 9t9 23zM1536 640q0 -209 -103 -385.5t-279.5 -279.5t-385.5 -103t-385.5 103t-279.5 279.5t-103 385.5t103 385.5t279.5 279.5t385.5 103t385.5 -103t279.5 -279.5t103 -385.5z'
  }),
  viewBox: '0 128 1536 1536'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/info.js
// module id = 1590
// module chunks = 0